import React from 'react';
import { Link } from 'react-router-dom';
import { HomlyLogo } from '../../components/brand/HomlyLogo';

const DISPLAY = { fontFamily: "'Space Grotesk', sans-serif" };

/**
 * ConvFooter — Minimal legal footer (logo + legal links + copyright).
 * Intentionally lean to keep focus on conversion.
 */
export const ConvFooter = () => {
    const year = new Date().getFullYear();
    return (
        <footer className="border-t border-white/[0.06] bg-[#050308]" data-testid="landing-footer">
            <div className="max-w-6xl mx-auto px-6 md:px-12 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
                <div className="flex items-center gap-3">
                    <HomlyLogo size="md" />
                    <span className="text-xs text-[#6E6A7A]">© {year} · Tous droits réservés</span>
                </div>
                <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-[#A19DAB]">
                    <Link to="/recherche" className="hover:text-white transition-colors" data-testid="footer-link-recherche">Trouver un agent</Link>
                    <Link to="/pour-les-agences" className="hover:text-white transition-colors" data-testid="footer-link-pour-agences">Pour les agences</Link>
                    <Link to="/pour-les-agents" className="hover:text-white transition-colors" data-testid="footer-link-pour-agents">Pour les agents</Link>
                    <Link to="/cgu" className="hover:text-white transition-colors" data-testid="footer-link-cgu">CGU</Link>
                    <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-link-privacy">Confidentialité</Link>
                    <Link to="/mentions-legales" className="hover:text-white transition-colors" data-testid="footer-link-mentions">Mentions légales</Link>
                    <Link to="/login" className="hover:text-white transition-colors" data-testid="footer-link-login">Connexion</Link>
                </nav>
            </div>
        </footer>
    );
};
